import { useABTest } from "Common/abTestUtils/hooks";

const useDisabilityEnabled = () => {
  const { isLoading, testValue: disabilityABTestValue } = useABTest("disability_insurance");
  const enabled = disabilityABTestValue === "show";

  return { isLoading, enabled };
};

export default useDisabilityEnabled;
